module.exports = __webpack_public_path__ + "img/MERRY CHRISTMAS.e234500.svg";